// document.addEventListener("product:added-to-cart", function (e) {
//   console.log('product:added-to-cart', e.detail)
// })

// Pre enable the in stock filter
if (window.requestPageType === 'collection' || window.requestPageType === 'search') {
  const filter = document.querySelector('input[name="filter.v.availability"][value="1"] + label')
  if (filter && !location.search.includes('filter.v.availability')) setTimeout(function () {
    filter.click()
  }, 500)
}

// Dynamic barcode as line property
if (window.requestPageType === 'product') {
  const input = document.querySelector('.section-main-product [name="properties[_barcode]"]')
  const variantPicker = document.querySelector('.section-main-product variant-picker')
  if (variantPicker && input) variantPicker.addEventListener('change', function () {
    // Delay function
    setTimeout(() => {
      input.value = variantPicker?.currentVariant?.barcode || ''
    }, 100);
  })
}